<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
// import { api } from "../../apis/main.js"
export default {
  name: 'App',
  components: {},
  mounted() {

  },
  computed: {

  },
  data() {
    return {
      district: [],
    }
  },
  methods: {
    
  },
}
</script>

<style>
</style>
